// import videos from '../assets/videos.mp4'
import points from '../assets/Services/points.png'
import { IoMdAdd, IoMdRemove } from "react-icons/io";
import { useEffect, useState } from 'react';
import { motion } from "framer-motion";



export default function Plaforms({ service, subservice }) {
    console.log(service, "Subss",subservice)
    const [openIndex, setOpenIndex] = useState(null);

    useEffect(() => {
        if (!subservice) return;

        const serviceId = subservice.title.replace(/\s+/g, "-");

        document.getElementById(serviceId)?.scrollIntoView({
            behavior: "smooth",
            block: "start",
        });
    }, [subservice]);
    return (
        <main>
            <section>
                <div className="bg-black w-full min-h-screen  flex justify-center lg:items-center">
                    <video
                        className=" w-full   sm:w-[80%] lg:w-[100%] h-auto object-contain"
                        autoPlay muted loop playsInline controls={false}
                        disablePictureInPicture
                        controlsList="nodownload nofullscreen noremoteplayback"
                        preload="auto"
                        onContextMenu={(e) => e.preventDefault()}>
                        <source src={service?.video} type="video/mp4" />
                    </video>


                </div>
            </section>

            <section className='px-6 sm:px-6 md:px-12 lg:px-24 max-w-7xl mx-auto pt-10 '>
                <h2 className='font-primary font-semibold text-center text-2xl md:text-4xl'>What We Offer</h2>
                <p className='text-center font-secondary text-slate-600 pt-5 font-normal text-base md:text-lg'>{service.description}</p>

            </ section>

            <section className='px-6 sm:px-6 md:px-24 lg:px-24 xl:px-10 max-w-7xl mx-auto py-10'>

                {service.services.map((value, index) => {

                    const isReverse = index % 2 !== 0;

                    return (

                        <div
                            key={value.title}
                            id={value.title.replace(/\s+/g, "-")}
                            className={`flex flex-col lg:flex-row items-center gap-10 py-10
                ${isReverse ? "lg:flex-row-reverse" : ""}
                `}
                        >

                            {/* LEFT CONTENT */}
                            <div className='w-full lg:w-1/2'>

                                <div className='flex items-center gap-3 md:gap-6'>

                                    <div className='relative'>
                                        <img src={points} alt="points" />

                                        <h3 className='absolute left-5 top-[21px] md:top-5 md:left-[20px] text-xl font-bold'>
                                            {value.number}
                                        </h3>
                                    </div>

                                    <h2 className='text-xl md:text-3xl font-semibold'>
                                        {value.title}
                                    </h2>

                                </div>

                                <p className='text-gray-600 font-secondary p-3 text-lg'>
                                    {value.description}
                                </p>

                                <div className="my-10 px-2">

                                    {value.features.map((content, i) => {

                                        const uniqueIndex = `${index}-${i}`;
                                        const isOpen = openIndex === uniqueIndex;

                                        return (

                                            <div key={i} className="relative">

                                                <div
                                                    onClick={() =>
                                                        setOpenIndex(
                                                            isOpen ? null : uniqueIndex
                                                        )
                                                    }
                                                    className="bg-white p-4 sm:p-5 my-5 flex items-start gap-4 sm:gap-6  cursor-pointer"
                                                >

                                                    <div className="flex-1">

                                                        <h6
                                                            className={`font-medium text-lg sm:text-xl transition-colors duration-300
                                                ${isOpen
                                                                    ? "text-secondary-500"
                                                                    : "text-black"
                                                                }`}
                                                        >
                                                            {content.title}
                                                        </h6>

                                                        <div
                                                            className={`overflow-hidden transition-all duration-500
                                                ${isOpen
                                                                    ? "max-h-[200px] opacity-100 mt-3"
                                                                    : "max-h-0 opacity-0"
                                                                }`}
                                                        >

                                                            <p className="text-gray-600 text-sm sm:text-base">
                                                                {content.description}
                                                            </p>

                                                        </div>

                                                    </div>

                                                    <button className="p-2 -m-2">

                                                        {isOpen ? (
                                                            <IoMdRemove className="text-xl text-secondary-500" />
                                                        ) : (
                                                            <IoMdAdd className="text-xl text-black" />
                                                        )}

                                                    </button>

                                                </div>

                                                {i !== 0 && <div className="absolute top-0 left-3 w-[95%] h-[1px] bg-gray-300"></div>}

                                            </div>

                                        );
                                    })}
                                </div>
                            </div>

                            {/* RIGHT IMAGE SECTION */}
                            <div className="h-[650px] overflow-hidden w-full max-w-xl">

                                <motion.div
                                    animate={{
                                        y: index % 2 === 0
                                            ? ["0%", "-50%", "0%"]
                                            : ["-50%", "0%", "-50%"],
                                    }}
                                    transition={{
                                        duration: 10 + index * 2,
                                        repeat: Infinity,
                                        ease: "easeInOut",
                                        repeatDelay: 1,
                                    }}
                                    className="flex flex-col gap-3"
                                >

                                    {/* FIRST SET */}
                                    <div className="grid grid-cols-2 gap-3">

                                        <div className="col-span-2 overflow-hidden">
                                            <img
                                                src={value.images[0]}
                                                alt={value.title}
                                                className="w-full h-[210px] object-cover rounded-2xl"
                                            />
                                        </div>

                                        <div className="overflow-hidden rounded-2xl">
                                            <img
                                                src={value.images[1]}
                                                alt={value.title}
                                                className="w-[500px] h-[200px] object-cover rounded-2xl"
                                            />
                                        </div>

                                        <div className="overflow-hidden rounded-2xl">
                                            <img
                                                src={value.images[2]}
                                                alt={value.title}

                                                className="w-[500px] h-[200px] object-cover rounded-2xl"
                                            />
                                        </div>

                                        <div className="col-span-2 overflow-hidden">
                                            <img
                                                src={value.images[3]}
                                                alt={value.title}
                                                className="w-full h-[210px] object-cover rounded-2xl"
                                            />
                                        </div>

                                    </div>


                                    {/* DUPLICATE SET */}
                                    <div className="grid grid-cols-2 gap-3">

                                        <div className="col-span-2 overflow-hidden">
                                            <img
                                                src={value.images[0]}
                                                alt={value.title}
                                                className="w-full h-[210px] object-cover rounded-2xl"
                                            />
                                        </div>

                                        <div className="overflow-hidden rounded-2xl">
                                            <img
                                                src={value.images[1]}
                                                alt={value.title}
                                                className="w-[500px] h-[200px] object-cover rounded-2xl"
                                            />
                                        </div>

                                        <div className="overflow-hidden rounded-2xl">
                                            <img
                                                src={value.images[2]}
                                                alt={value.title}
                                                className="w-[500px] h-[200px] object-cover rounded-2xl"
                                            />
                                        </div>

                                        <div className="col-span-2 overflow-hidden">
                                            <img
                                                src={value.images[3]}
                                                alt={value.title}
                                                className="w-full h-[210px] object-cover rounded-2xl"
                                            />
                                        </div>

                                    </div>

                                </motion.div>

                            </div>

                        </div>

                    );
                })}
            </section>

        </main >
        // <><p>this</p></>
    )
}
